import { mapState } from 'vuex'
import myHeader from "@/views/components/header";
import myFooter from "@/views/components/footer";
import myContact from "@/views/components/contact";
// api
import ModelService from '@/services/model.service'

export default {
  name: 'Index',
  data() {
    return {
      navListData: [],
      languageData: [],
      factoryData: [],
    };
  },
  components: {
    myHeader,
    myFooter,
    myContact,
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    language: {
      immediate: false,
      handler(lang) {
        this.init();
      },
    },
  },
  mounted() {
    this.getLanguageList();
    this.init();

    console.log('language: ', this.language);
    console.log('index: ', this.LangIndex);
    console.log('isPC: ', this.isPC);
  },
  methods: {
    init() {
      this.getNavList();
      this.getFactoryList();
    },
    // 获取语言列表
    getLanguageList() {
      ModelService.languageList().then((res) => {
        if (res.code === 0) {
          this.languageData = res.data;
        }
      });
    },
    // 获取导航列表
    getNavList() {
      const language = {
        lang: this.language
      };
      ModelService.navList(language).then((res) => {
        if (res.code === 0) {
          this.navListData = res.data;
        }
      });
    },
    // 获取工厂列表
    getFactoryList() {
      const language = {
        lang: this.language
      };
      ModelService.getFactoryList(language).then((res) => {
        if (res.code === 0) {
          this.factoryData = res.data;
          this.$store.commit("setFactoryList", res.data);
        }
      });
    },
    openContact() {
      this.$refs.myContact.show();
    },
  },
};
